import React, { useState } from 'react';
import { CustomIcon } from './CustomIcon';
import { useSwipeable } from 'react-swipeable';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
export const Testimonials = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const testimonials = [{
    name: 'Mariana Torres',
    role: 'Ex contadora frustrada, hoy mentora financiera',
    quote: 'Durante años hice los presupuestos de otros, pero nunca entendí cómo ordenar mi propio dinero. Pensé que era culpa mía… hasta que vi que los métodos que usaba eran importados, irreales. Cuando adapté todo a mi contexto, mi economía personal floreció. Hoy, ayudo a otros latinos a lograr lo mismo.',
    achievement: 'Mariana ahora enseña su sistema en talleres para mujeres en Argentina, Perú y Colombia.',
    icon: 'chart'
  }, {
    name: 'Andrés Guzmán',
    role: 'Ex empleado bancario, hoy educador de finanzas locales',
    quote: 'Yo trabajaba en un banco. Y veía cómo la mayoría de clientes se endeudaban usando productos que no entendían. Los entrenábamos con técnicas que venían de EE.UU., sin aplicar a nuestra realidad. Un día dije basta. Hoy, mi método ayuda a familias a salir del ahogo financiero… sin fórmulas vacías.',
    achievement: 'Andrés ha ayudado a más de 5.000 personas en Latinoamérica a recuperar el control sin endeudarse más.',
    icon: 'credit-card'
  }, {
    name: 'Paola Rivera',
    role: 'Emprendedora, sobreviviente de inflación extrema',
    quote: 'Cuando mi país tuvo inflación de tres cifras, me di cuenta de que ningún libro financiero aplicaba. Tuve que crear mi propio sistema, desde cero. Hoy no solo tengo estabilidad… tengo libertad. Y eso quiero enseñarte: a construir tu seguridad, aun cuando todo a tu alrededor sube menos tu sueldo.',
    achievement: 'Paola es autora de "Finanzas de Guerrilla", y enseña en comunidades de bajos ingresos en Venezuela y Ecuador.',
    icon: 'arrow-up'
  }];
  const nextSlide = () => {
    setCurrentSlide(prev => (prev + 1) % testimonials.length);
  };
  const prevSlide = () => {
    setCurrentSlide(prev => (prev - 1 + testimonials.length) % testimonials.length);
  };
  const handlers = useSwipeable({
    onSwipedLeft: () => nextSlide(),
    onSwipedRight: () => prevSlide(),
    trackMouse: true
  });
  return <section id="testimonios" className="py-16 bg-gradient-to-b from-white to-orange-50" data-id="element-309">
      <div className="container mx-auto px-4" data-id="element-310">
        <div className="text-center mb-12" data-id="element-311">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-312">
            Historias Reales de Transformación
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-313">
            Personas como tú que dejaron de seguir métodos importados y crearon
            su propia libertad financiera
          </p>
        </div>
        <div className="hidden md:grid grid-cols-1 md:grid-cols-3 gap-8 max-w-7xl mx-auto" data-id="element-314">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white p-8 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300" data-id="element-315">
              <div className="flex items-center mb-6" data-id="element-316">
                <div className="bg-orange-100 p-4 rounded-full mr-4" data-id="element-317">
                  <CustomIcon name={testimonial.icon} size={32} className="text-orange-600" data-id="element-318" />
                </div>
                <div data-id="element-319">
                  <h3 className="text-xl font-bold text-gray-900" data-id="element-320">
                    {testimonial.name}
                  </h3>
                  <p className="text-sm text-orange-600 font-medium" data-id="element-321">
                    {testimonial.role}
                  </p>
                </div>
              </div>
              <blockquote className="text-gray-700 mb-6 italic" data-id="element-322">
                "{testimonial.quote}"
              </blockquote>
              <div className="pt-6 border-t border-gray-200" data-id="element-323">
                <p className="text-sm text-gray-600 font-medium" data-id="element-324">
                  {testimonial.achievement}
                </p>
              </div>
            </div>)}
        </div>
        <div className="md:hidden relative" data-id="element-325">
          <div {...handlers} className="overflow-hidden" data-id="element-326">
            <div className="flex transition-transform duration-300 ease-in-out" style={{
            transform: `translateX(-${currentSlide * 100}%)`
          }} data-id="element-327">
              {testimonials.map((testimonial, index) => <div key={index} className="w-full flex-shrink-0 px-4" data-id="element-328">
                  <div className="bg-white p-8 rounded-lg shadow-lg" data-id="element-329">
                    <div className="flex items-center mb-6" data-id="element-330">
                      <div className="bg-orange-100 p-4 rounded-full mr-4" data-id="element-331">
                        <CustomIcon name={testimonial.icon} size={32} className="text-orange-600" data-id="element-332" />
                      </div>
                      <div data-id="element-333">
                        <h3 className="text-xl font-bold text-gray-900" data-id="element-334">
                          {testimonial.name}
                        </h3>
                        <p className="text-sm text-orange-600 font-medium" data-id="element-335">
                          {testimonial.role}
                        </p>
                      </div>
                    </div>
                    <blockquote className="text-gray-700 mb-6 italic" data-id="element-336">
                      "{testimonial.quote}"
                    </blockquote>
                    <div className="pt-6 border-t border-gray-200" data-id="element-337">
                      <p className="text-sm text-gray-600 font-medium" data-id="element-338">
                        {testimonial.achievement}
                      </p>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
          <button onClick={prevSlide} className="absolute left-0 top-1/2 -translate-y-1/2 bg-white rounded-full p-2 shadow-lg hover:bg-gray-100 transition-colors" aria-label="Anterior testimonio" data-id="element-339">
            <ChevronLeftIcon size={24} className="text-gray-700" data-id="element-340" />
          </button>
          <button onClick={nextSlide} className="absolute right-0 top-1/2 -translate-y-1/2 bg-white rounded-full p-2 shadow-lg hover:bg-gray-100 transition-colors" aria-label="Siguiente testimonio" data-id="element-341">
            <ChevronRightIcon size={24} className="text-gray-700" data-id="element-342" />
          </button>
          <div className="flex justify-center gap-2 mt-6" data-id="element-343">
            {testimonials.map((_, index) => <button key={index} onClick={() => setCurrentSlide(index)} className={`w-2 h-2 rounded-full transition-all ${currentSlide === index ? 'bg-orange-600 w-8' : 'bg-gray-300'}`} aria-label={`Ir al testimonio ${index + 1}`} data-id="element-344" />)}
          </div>
        </div>
      </div>
    </section>;
};